import React, { useEffect, useRef } from "react";
import { Editor } from "@toast-ui/react-editor";
import "@toast-ui/editor/dist/toastui-editor.css";
import clientsService from "../../../services/clientsService.js";

const ModalClientContent = ({ isOpen, onClose, client }) => {
    const editorRef = useRef();

    useEffect(() => {
        if (client?.content && editorRef.current) {
            editorRef.current.getInstance().setHTML(client.content);
        }
    }, [client]);

    const handleSave = async () => {
        const editorInstance = editorRef.current?.getInstance();
        const htmlContent = editorInstance.getHTML();

        try {
            await clientsService.updateClient(client.id, { content: htmlContent });
            onClose();
        } catch (error) {
            console.error("Error al guardar el contenido:", error);
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay">
            <div className="modal-content modal-content-lg">
                <button className="close-button" onClick={onClose}>
                    &times;
                </button>
                <h2 className="modal-title">Editar Contenido</h2>

                <Editor
                    previewStyle="vertical"
                    height="400px"
                    initialEditType="wysiwyg"
                    hideModeSwitch={true}
                    useCommandShortcut={true}
                    ref={editorRef}
                />

                <div className="mt-3">
                    <button className="btn btn-primary" onClick={handleSave}>
                        <i className="bi bi-save me-2"></i> Guardar
                    </button>
                    <button className="btn btn-secondary ms-2" onClick={onClose}>
                        <i className="bi bi-x-circle me-2"></i> Cancelar
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ModalClientContent;
